import React, { useState, useEffect } from 'react';
import { NavItem, Nav } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { MenuDatosPersonalesV2 } from './DatosPersonales/MenuDatosPersonalesV2';
import { ImpresionDocumentos } from './ImpresionDocumentos/ImpresionDocumentos';
import HeaderInicio from '../../util/headerInicio';
import { FirmaContrato } from './Contrato/FirmaContrato';
//import { ObtieneDatosPostulanteLogic, GrabarDatosPostulanteLogic } from './../../view-model/Inicio/InicioEstudiante.logic';
import { AlumnoAntiguo } from './MontoCae/AlumnoAntiguo';
import { Finalizado } from './Finalizado/Finalizado';
import { Validacion } from '../PostExt/Validacion/Validacion';
import { AlumnoNuevo } from './MontoCae/AlumnoNuevo';
import { Pago } from './PagoWebPay/Pago';
import { FormaPago } from './SeleccionFormaPago/FormaPago';
import IViewRepresentanteFinanciero from '../../view-interfaces/IViewPersona';
//import { ObtieneRepresentanteFinancieroLogic, GrabarRepresentanteFinancieroLogic } from '../../view-model/DatosPersonales/DatosPersonales.logic';
import { ObtieneDatosPersonalesLogic } from '../../view-model/DatosPersonales/DatosPersonales.logic';
import { ObtenerMatriculaLogic } from '../../view-model/Matricula/Matricula.logic';
// import { ObtieneEtapasLogic } from '../../view-model/Inicio/PostulacionesEstudiante.logic';
import IViewPostulante from './../../view-interfaces/IViewPostulante';
import { animateScroll as scroll } from 'react-scroll';
//Iconos
// import d1 from '../../../assets/dist/svg/main.svg';
import d2 from '../../../assets/dist/svg/main.svg';
import { Alumno } from './DatosPersonales/Alumno';
import IViewComunas from '../../view-interfaces/IViewComunas';
import IViewComunasAuto from '../../view-interfaces/IViewComunasAuto';
import { ObtieneComunaLogic } from '../../view-model/Combos/Combos.logic';
import MensajeToken from '../../../Components/MensajeToken/MensajeToken';

type Props = {
    rut: number;
    codCarrera: string;
    codigoNegocio: number;
    codigoPlanificacionAcademica: number;
    codsede: string;
    nombreCarrera: string;
    numeroAlumno: string;
    listaComunas: IViewComunasAuto[];
};

export const Menu: React.FC<Props> = ({
    rut,
    codCarrera,
    codigoNegocio,
    codigoPlanificacionAcademica,
    codsede,
    nombreCarrera,
    numeroAlumno,
}) => {
    const history = useHistory();
    const location = useLocation();

    const [menu, setMenu] = useState('1');
    const [nuevo, setNuevo] = useState(false);
    const [rutPostulante, setRutPostulante] = useState(0);
    const [codCarreraPostulante, setCodCarreraPostulante] = useState('');
    //const [numeroAlumnoPostulante, setNumeroAlumnoPostulante] = useState('');
    const [codigoNegocioPostulante, setCodigoNegocioPostulante] = useState(0);
    const [anioPromocionParametro, setAnioPromocionParametro] = useState(0);
    const [periodoPromocionParametro, setPeriodoPromocionParametro] = useState(0);

    const [nombreCarreraPostulante, setNombreCarreraPostulante] = useState('');
    //const [sedePostulante, setSedePostulante] = useState('')
    const [nombreAlumno, setNombreAlumno] = useState('');
    const [cargandoMatricula, setCargandoMatricula] = useState(true);

    const [matriculado, setMatriculado] = useState(false);

    const [formaPago, setFormaPago] = useState([]);
    const [DatosAlumno, setDatosAlumno] = useState([]);
    const [listaComunas, setlistaComunas] = useState([]);

    const [textMenuResponsive, setTextMenuResponsive] = useState('');

    const [tieneRF, setTieneRF] = useState(false);
    const [debeFirmar, setDebeFirmar] = useState(false);

    const [Error, setError] = useState(true)


    const _listComuna: IViewComunasAuto = { ID: 0, descripcion: '' };
    const _comunasAuto: Array<IViewComunasAuto> = [];
    const [ListaComunasAuto, setListaComunasAuto] = useState(_comunasAuto);
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
  const [codNegocio, setCodNegocio] = useState(0)
    useEffect(() => {
        handleCargaComunas();
    }, [])

    const handleCargaComunas = () => {
        ObtieneComunaLogic(selListaComunas, codigoNegocio);
    }

    const selListaComunas = (error: Boolean, err: string, Comunas: IViewComunas[], _Comunas: IViewComunasAuto[]) => {
        try {
            if (error === false && Comunas.length > 0) {
                setListaComunasAuto(_Comunas);
            }
        } catch (er) {
            console.log('er', er);
        }
    }

    const handleCargaDatosIniciales = () => {
        scroll.scrollToTop();
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        console.log('PARAMETRO MENU');
        //console.log('parametros menu'+_params);
        setDebeFirmar(_params.debeFirmar);
        if (_params.CodigoNegocio !== 1) {
            ObtieneDatosPersonalesLogic(selListaPostulante, _params.headers, _params.rut, "", _params.codigoNegocio, 1);
        }
        // if (_params.CodigoNegocio === 2) {
        //     ObtieneRepresentanteFinancieroLogic(selListaRepresentanteFinanciero, _params.rut, _params.codCarrera, _params.CodigoNegocio, "");
        // }
        if (_params.rut !== null) {
            rut = Number(_params.rut);
        }

        setRutPostulante(Number(_params.rut));
        setNombreAlumno(_params.nombreAlumno);
        codCarrera = _params.codCarrera;
        setCodCarreraPostulante(codCarrera);
        codigoNegocio = _params.codigoNegocio;
        setCodigoNegocioPostulante(codigoNegocio);
        codigoPlanificacionAcademica = _params.codigoPlanificacionAcademica;
        // sede = _params.sede;
        setNombreCarreraPostulante(_params.nombreCarrera);
        //setSedePostulante(_params.sede)
        codsede = _params.codsede;
        // nombreCarrera = _params.nombreCarrera;
        //numeroAlumno = _params.numeroAlumno;
        // setNumeroAlumnoPostulante(numeroAlumno);
        setAnioPromocionParametro(_params.anioPromocion);
        setPeriodoPromocionParametro(_params.periodoPromocion);

        if (_params.menu !== '') {
            setMenu(_params.menu.toString());
        }
        // setRutParametro(Number(_params.rut))
    };

    const selListaPostulante = (error: Boolean, err: string, Estudiante: any) => {
        //let _tt = JSON.stringify(location.state);
        //let _params = JSON.parse(_tt)
        try {
            if (Estudiante[0].run.toString().trim().length > 1) {
                console.log('Datos estudiante ->' + Estudiante[0])
                setDatosAlumno(Estudiante[0])
                if (nombreAlumno.length == 0)
                    setNombreAlumno(Estudiante[0].nombreCompleto);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }

        } catch (error) {
            console.log('error', error);
        }
    }
    // const selResultadoParametrosAlumno = (error: Boolean, err: string, Resultado: any) => {
    //     try {
    //         if (error === false && Resultado.length > 0) {

    //         }
    //     } catch (err) {
    //         console.log('error', err);
    //     }
    // }
    useEffect(() => {
        let text = '';
        if (menu === '1') text = 'Datos personales';
        else if (menu === '3') text = 'Selección de forma de pago';
        else if (menu === '4') text = 'Pago';
        else if (menu === '5') text = 'Carga de documentos';
        else if (menu === '6') text = 'Firma de Contrato';
        else if (menu === '7') text = 'Generar Matrícula';

        setTextMenuResponsive(text);
    }, [menu]);

    // Obtener los parámetros de la URL
    const searchParams = new URLSearchParams(location.search);

    // Agregar el valor de idPeriodo al objeto de estado location.state

    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: '/Inicio',
            });
        } else {
            GenerarMatricula();
            handleCargaDatosIniciales();
        }
    }, []);

    const handlecambioMenu = (cambio: string) => {
        scroll.scrollToTop();
        setMenu(cambio);
        GenerarMatricula();
    };

    const handleActualizarMenu = (actualizar: boolean) => {
        console.log('ACTUALIZAR MENU...');

        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        _params.debeFirmar = actualizar;
        setDebeFirmar(actualizar);
    };

    const handleFormaPago = (forma: any) => {
        setFormaPago(forma);
    };

    const GenerarMatricula = () => {
        let _tt = JSON.stringify(location.state);
        //console.log(_tt);
        let _params = JSON.parse(_tt);
        /* console.log(_params) */
        setCargandoMatricula(true);
        ObtenerMatriculaLogic(
            selObtenerMatricula,
            _params.rut,
            _params.codCarrera,
            _params.codigoNegocio,
            _params.codigoPlanificacionAcademica,
            _params.idPeriodo,
        );
        /* GenerarMatriculaLogic(selGenerarMatricula, _params.idProceso) */
    };
    const selObtenerMatricula = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            setMatriculado(data);
            //selListaPostulante(data);
        }
        setCargandoMatricula(false);
    };
    /*   useEffect(() => {
          try {
              let _tt = JSON.stringify(location.state);
              let _params = JSON.parse(_tt);
              if (matriculado) {
                  if (_params.codigoNegocio === 1) {
                      if (menu !== '7') {
                          history.push({
                              pathname: '/carreras',
                              state: {
                                  rut: _params.rut,
                              },
                          });
                      }
                  } else {
                      if (menu !== '7') {
                          history.push({
                              pathname: '/inicio',
                              state: {
                                  rut: _params.rut,
                              },
                          });
                      }
                  }
              }
          } catch (e: any) {
              console.log('Problemas al obtener si esta matriculado.');
          }
      }, [matriculado]); */

    return (
        <>
            <HeaderInicio mostrarCallCenter={menu === '3' && !cargandoMatricula ? false : true} />

            <div style={{ backgroundColor: 'rgb(243 243 251)' }}>
                {menu === '1' ? (
                    <div>
                        <br />
                        <br />
                        <div className="header-menu" /* style={{ padding: '0px 350px 0px 350px' }} */>
                            <h1 style={{ color: '#0062a1', textAlign: 'center' }}>
                                <strong>Datos Personales</strong>
                            </h1>
                            {/*  {
                                    codigoNegocioPostulante === 1 ?
                                        <div style={{ fontSize: 12 }}>
                                            <div style={{ display: 'list-item' }} className="enrollment__subtitle"><strong>Si eres menor de edad (menor de 18 años) debes ir presencialmente a realizar tu proceso de Matrícula de lunes a viernes entre las 8 y las 18 hrs.</strong></div>
                                            <div style={{ display: 'list-item' }} className="enrollment__subtitle">Por favor revisar datos personales del Alumno y actualizar los que correspondan. Si el nombre del postulante/alumno tiene un error, por favor comunicarse a través del formulario de atención: <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/"><u>https://contacto.udd.cl/</u></a>.</div>
                                            <div style={{ display: 'list-item' }} className="enrollment__subtitle">{instrucciones2}</div>
                                            <div style={{ display: 'list-item' }} className="enrollment__subtitle">{instrucciones3}</div>
                                        </div>
                                        :
                                        <div style={{ fontSize: 12 }}>
                                            <div style={{ display: 'list-item' }} className="enrollment__subtitle">Por favor revisar datos personales, si tiene un error, por favor comunicarse a través del formulario de atención: <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/" target="_blank"><u>Formulario contacto UDD</u></a>.</div>
                                        </div>
                                } */}
                            <br />
                            {/* <p style={{ fontSize: 14 }}><strong>Nombre del Postulante: {`${nombreAlumno}`}</strong> </p> */}
                            {/* <p style={{ fontSize: 14 }}><strong>Programa al que postula: {`${nombreCarrera} - ${sede}`}</strong> </p> */}
                            <p style={{ fontSize: 14 }}>
                                <strong>{`${nombreAlumno}`}</strong>
                            </p>
                            {codigoNegocioPostulante !== 3 ? (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            ) : (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            )}
                        </div>
                    </div>
                ) : menu === '3' ? (
                    <div>
                        <br />
                        <br />
                        <div className="header-menu">
                            <h1 style={{ color: '#0062a1', textAlign: 'center' }}>
                                <strong>Formas de Pago</strong>
                            </h1>
                            {/* <p style={{ fontSize: 12, display: 'list-item' }}>A continuación debe elegir la forma de pago para la Matrícula y Arancel según corresponda.</p> */}
                            {/* <p style={{ fontSize: 14 }}><strong>Nombre del Postulante: {`${nombreAlumno}`}</strong> </p>
                                    <p style={{ fontSize: 14 }}><strong>Programa al que postula: {`${nombreCarrera} - ${sede}`}</strong> </p> */}
                            <p style={{ fontSize: 14 }}>
                                <strong>{`${nombreAlumno}`}</strong>
                            </p>
                            {codigoNegocioPostulante !== 3 ? (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            ) : (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            )}
                        </div>
                    </div>
                ) : menu === '4' ? (
                    <div>
                        <br />
                        <br />
                        <div className="header-menu">
                            <h1 style={{ color: '#0062a1', textAlign: 'center' }}>
                                <strong>Pago</strong>
                            </h1>
                            {/* <p style={{ fontSize: 12, display: 'list-item' }}>A continuación deberás pagar las opciones seleccionadas anteriormente:</p> */}
                            {/* <p style={{ fontSize: 14 }}><strong>Nombre del Postulante: {`${nombreAlumno}`}</strong> </p>
                                    <p style={{ fontSize: 14 }}><strong>Programa al que postula: {`${nombreCarrera} - ${sede}`}</strong> </p> */}
                            <p style={{ fontSize: 14 }}>
                                <strong>{`${nombreAlumno}`}</strong>
                            </p>
                            {codigoNegocioPostulante !== 3 ? (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            ) : (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            )}
                        </div>
                    </div>
                ) : menu === '5' ? (
                    <div>
                        <br />
                        <br />
                        <div className="header-menu">
                            <h1 style={{ color: '#0062a1', textAlign: 'center' }}>
                                <strong>Carga de Documentos</strong>
                            </h1>
                            {/* <p style={{ fontSize: 12, display: 'list-item' }}>A continuación deberás cargar los documentos solicitados en los formatos PDF o JPG, de lo contrario, no podrás finalizar el proceso de matrícula.</p> */}
                            {/* <p style={{ fontSize: 14 }}><strong>Nombre del Postulante: {`${nombreAlumno}`}</strong> </p>
                                    <p style={{ fontSize: 14 }}><strong>Programa al que postula: {`${nombreCarrera} - ${sede}`}</strong> </p> */}
                            <p style={{ fontSize: 14 }}>
                                <strong>{`${nombreAlumno}`}</strong>
                            </p>
                            {codigoNegocioPostulante !== 3 ? (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            ) : (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            )}
                        </div>
                    </div>
                ) : menu === '6' ? (
                    <div>
                        <br />
                        <br />
                        <div className="header-menu">
                            <h1 style={{ color: '#0062a1', textAlign: 'center' }}>
                                <strong>Firma de Contrato</strong>
                            </h1>
                            {/* {
                                        codigoNegocioPostulante === 1 ?
                                            <div style={{ marginBottom: '2rem', color: 'gray', fontSize: 12 }}>
                                                <div className="enrollment__subtitle">A continuación el alumno y responsable financiero deberán firmar el Contrato de Servicios Educacionales mediante firma electrónica simple.</div>
                                            </div>
                                            :
                                            <div style={{ marginBottom: '2rem', color: 'gray', fontSize: 12 }}>
                                                <div className="enrollment__subtitle">A continuación el alumno/responsable financiero deberá firmar el Contrato de Servicios Educacionales mediante firma electrónica simple, de lo contrario, no podrá finalizar el proceso de matrícula.</div>
                                            </div>
                                    } */}
                            {/* <p style={{ fontSize: 14 }}><strong>Nombre del Postulante: {`${nombreAlumno}`}</strong> </p>
                                    <p style={{ fontSize: 14 }}><strong>Programa al que postula: {`${nombreCarrera} - ${sede}`}</strong> </p> */}
                            <p style={{ fontSize: 14 }}>
                                <strong>{`${nombreAlumno}`}</strong>
                            </p>
                            {codigoNegocioPostulante !== 3 ? (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            ) : (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            )}
                        </div>
                    </div>
                ) : menu === '7' ? (
                    <div>
                        <br />
                        <br />
                        <div className="header-menu">
                            <h1 style={{ color: '#0062a1', textAlign: 'center' }}>
                                <strong> Generación Matrícula</strong>
                            </h1>
                            {/* <p style={{ fontSize: 12, display: 'list-item' }}>A continuación debe elegir la forma de pago para la Matrícula y Arancel según corresponda.</p> */}
                            {/* <p style={{ fontSize: 14 }}><strong>Nombre del Postulante: {`${nombreAlumno}`}</strong> </p>
                                    <p style={{ fontSize: 14 }}><strong>Programa al que postula: {`${nombreCarrera} - ${sede}`}</strong> </p> */}
                            <p style={{ fontSize: 14 }}>
                                <strong>{`${nombreAlumno}`}</strong>
                            </p>
                            {codigoNegocioPostulante !== 3 ? (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            ) : (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            )}
                        </div>
                    </div>
                ) : menu === '8' ? (
                    <div>
                        <br />
                        <br />
                        <div className="header-menu">
                            <h1 style={{ color: '#0062a1', textAlign: 'center' }}>
                                <strong>Declaración y Autorización</strong>
                            </h1>
                            {/* <p style={{ fontSize: 12, display: 'list-item' }}>A continuación debe elegir la forma de pago para la Matrícula y Arancel según corresponda.</p> */}
                            {/* <p style={{ fontSize: 14 }}><strong>Nombre del Postulante: {`${nombreAlumno}`}</strong> </p>
                                    <p style={{ fontSize: 14 }}><strong>Programa al que postula: {`${nombreCarrera} - ${sede}`}</strong> </p> */}
                            <p style={{ fontSize: 14 }}>
                                <strong>{`${nombreAlumno}`}</strong>
                            </p>
                            {codigoNegocioPostulante !== 3 ? (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            ) : (
                                <p style={{ fontSize: 14 }}>
                                    <strong>{`${nombreCarreraPostulante}`}</strong>
                                </p>
                            )}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                <div
                    className="header-menu2"
                    style={{
                        backgroundColor: '#fff',
                        display: 'flex',
                        placeContent: 'center',
                        marginBottom: 50,
                        fontSize: '1rem',
                    }}
                >
                    <Nav
                        className="enrollment-header__breadcrumb"
                        activeKey="1" /* onSelect={(k: any) => setMenu(k)} */
                    >
                        <p className="enrollment-header__hide">
                            Estás en:{' '}
                            <a data-toggle="collapse" className="enrollment-header__hide-breadcrumbs">
                                {textMenuResponsive}
                            </a>
                        </p>
                        <ul id="collapsebreadcrumb" className="collapse">
                            {codigoNegocioPostulante === 1 || codigoNegocioPostulante === 2 ? (
                                <Nav.Item>
                                    <Nav.Link className="enrollment-header__item" eventKey="1">
                                        <span
                                            className={
                                                menu === '1'
                                                    ? 'enrollment-header__enlace enrollment-header__enlace--current'
                                                    : 'enrollment-header__enlace'
                                            }
                                        >
                                            Datos personales
                                        </span>
                                        <svg className="svg-chevron-right-dims">
                                            <use xlinkHref={d2 + '#chevron-right'}></use>
                                        </svg>
                                    </Nav.Link>
                                </Nav.Item>
                            ) : (
                                ''
                            )}
                            <Nav.Item>
                                <Nav.Link className="enrollment-header__item" eventKey="3">
                                    <span
                                        className={
                                            menu === '3'
                                                ? 'enrollment-header__enlace enrollment-header__enlace--current'
                                                : 'enrollment-header__enlace'
                                        }
                                    >
                                        Selección de forma de pago
                                    </span>
                                    <svg className="svg-chevron-right-dims">
                                        <use xlinkHref={d2 + '#chevron-right'}></use>
                                    </svg>
                                </Nav.Link>
                            </Nav.Item>
                            {((codigoNegocioPostulante === 2 && tieneRF) ||
                                codigoNegocioPostulante === 1 ||
                                codigoNegocioPostulante === 3) &&
                                debeFirmar ? (
                                <Nav.Item>
                                    <Nav.Link className="enrollment-header__item" eventKey="4">
                                        <span
                                            className={
                                                menu === '4'
                                                    ? 'enrollment-header__enlace enrollment-header__enlace--current'
                                                    : 'enrollment-header__enlace'
                                            }
                                        >
                                            Pago
                                        </span>
                                        <svg className="svg-chevron-right-dims">
                                            <use xlinkHref={d2 + '#chevron-right'}></use>
                                        </svg>
                                    </Nav.Link>
                                </Nav.Item>
                            ) : debeFirmar ? (
                                <Nav.Item>
                                    <Nav.Link className="enrollment-header__item" eventKey="4">
                                        <span
                                            className={
                                                menu === '4'
                                                    ? 'enrollment-header__enlace enrollment-header__enlace--current'
                                                    : 'enrollment-header__enlace'
                                            }
                                        >
                                            Pago
                                        </span>
                                        <svg className="svg-chevron-right-dims">
                                            <use xlinkHref={d2 + '#chevron-right'}></use>
                                        </svg>
                                    </Nav.Link>
                                </Nav.Item>
                            ) : (
                                <Nav.Item>
                                    <Nav.Link className="enrollment-header__item" eventKey="4">
                                        <span
                                            className={
                                                menu === '4'
                                                    ? 'enrollment-header__enlace enrollment-header__enlace--current'
                                                    : 'enrollment-header__enlace'
                                            }
                                        >
                                            Pago
                                        </span>
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                            {codigoNegocioPostulante === 1 || codigoNegocioPostulante === 2 || codigoNegocioPostulante === 3 ? (
                                ((codigoNegocioPostulante === 2 && tieneRF) ||
                                    codigoNegocioPostulante === 1 ||
                                    codigoNegocioPostulante === 3) &&
                                    debeFirmar ? (
                                    <Nav.Item>
                                        <Nav.Link className="enrollment-header__item" eventKey="5">
                                            <span
                                                className={
                                                    menu === '5'
                                                        ? 'enrollment-header__enlace enrollment-header__enlace--current'
                                                        : 'enrollment-header__enlace'
                                                }
                                            >
                                                Carga de documentos
                                            </span>
                                            <svg className="svg-chevron-right-dims">
                                                <use xlinkHref={d2 + '#chevron-right'}></use>
                                            </svg>
                                        </Nav.Link>
                                    </Nav.Item>
                                ) : (
                                    ''
                                )
                            ) : (
                                ''
                            )}
                            {
                                //codigoNegocioPostulante === 1 || codigoNegocioPostulante === 2 || debeFirmar ?
                                debeFirmar ? (
                                    <Nav.Item>
                                        <Nav.Link className="enrollment-header__item" eventKey="6">
                                            <span
                                                className={
                                                    menu === '6'
                                                        ? 'enrollment-header__enlace enrollment-header__enlace--current'
                                                        : 'enrollment-header__enlace'
                                                }
                                            >
                                                Firma de contrato
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                ) : (
                                    ''
                                )
                            }
                            {/* <Nav.Item>
                                <Nav.Link className="enrollment-header__item" eventKey="7">
                                <span className={menu === "7" ? "enrollment-header__enlace enrollment-header__enlace--current" : "enrollment-header__enlace"}>Genera Matrícula</span>
                                </Nav.Link>
                            </Nav.Item> */}
                        </ul>
                    </Nav>
                </div>
            </div>
            {cargandoMatricula ? (
                <div style={{ textAlign: 'center', marginTop: 100 }}>
                    <CircularProgress disableShrink />
                    <br />
                    <a>
                        <span>Cargando datos.</span>
                    </a>
                </div>
            ) : (
                ''
            )}
            {menu === '1' &&
                rutPostulante > 0 &&
                codCarreraPostulante.length > 0 &&
                codigoNegocioPostulante > 0 &&
                !cargandoMatricula ? (
                <MenuDatosPersonalesV2
                    rut={rutPostulante}
                    codigoNegocio={codigoNegocioPostulante}
                    codCarrera={codCarreraPostulante}
                    numeroAlumno={numeroAlumno}
                    anioPromocion={anioPromocionParametro}
                    periodoPromocion={periodoPromocionParametro}
                    onClickContinuar={handlecambioMenu}
                    onRefreshMenu={handleActualizarMenu}
                />
            ) : (
                ''
            )}
            {menu === '2' && nuevo && !cargandoMatricula ? <AlumnoNuevo /> : ''}
            {menu === '2' && !nuevo && !cargandoMatricula ? <AlumnoAntiguo /> : ''}
            {menu === '3' && !cargandoMatricula ? (
                <FormaPago
                    onClickContinuar={handlecambioMenu}
                    formaPago={handleFormaPago}
                    formaPago2={formaPago}
                    DatosAlumno={DatosAlumno}
                    codigoNegocio={codigoNegocioPostulante}
                    listaComunas={ListaComunasAuto}
                />
            ) : (
                ''
            )}
            {menu === '4' && !cargandoMatricula ? <Pago onClickContinuar={handlecambioMenu} /> : ''}
            {menu === '5' && !cargandoMatricula ? <ImpresionDocumentos onClickContinuar={handlecambioMenu} /> : ''}
            {menu === '6' && !cargandoMatricula ? (
                <FirmaContrato
                    rut={rutPostulante}
                    codCarrera={codCarreraPostulante}
                    codigoNegocio={codigoNegocioPostulante}
                    anioPromocion={anioPromocionParametro}
                    periodoPromocion={periodoPromocionParametro}
                    onClickContinuar={handlecambioMenu}
                />
            ) : (
                ''
            )}
            {menu === '7' ? <Finalizado firma={debeFirmar} onClickContinuar={handlecambioMenu} /> : ''}
            {menu === '8' ? <Validacion onClickContinuar={handlecambioMenu} /> : ''}
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    );
};
